import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ConcentrationContainerV2 } from 'packages/borrowing-base/ui/ConcentrationContainerV2';
import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';

export const InsightsConcentrationRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  // Use this variable for errors that bubble up to the component level route
  // This ensures we only toast the error once when there are multiple errors
  // We should use Chakra's toast.isActive, or a react hook in general, but the state re-renders when there are multiple errors in a given error boundary
  let routeLevelError = false;
  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights concentration page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <InsightsTemplate selectedTab={TAB_OPTION_KEYS.concentration}>
          <ConcentrationContainerV2 />
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
